export default __webpack_public_path__ + "static/media/4HP.6e664d8a.svg";